<template>
    <v-container fluid id="tours-container">
        <ToursBanner></ToursBanner>
        <ToursMain></ToursMain>
    </v-container>
</template>
<script>
import ToursCard from '@/components/ui/ToursCard.vue';
import ToursBanner from '@/components/ui/ToursBanner.vue';
import ToursMain from '@/components/layout/ToursMain.vue'

export default {
    name: 'Tours',
    components: {
        ToursCard,
        ToursMain,
        ToursBanner
    }
};
</script>
<style scoped>
</style>
